var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLPwhatsappicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "whatsapp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.346,
    height: 16.346,
    viewBox: "0 0 16.346 16.346",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_48367",
    "data-name": "Caminho 48367",
    d: "M13.83,11.77l-.006.051c-1.5-.746-1.654-.846-1.848-.556-.134.2-.525.657-.643.791s-.238.143-.44.051A5.528,5.528,0,0,1,9.256,11.1a6.179,6.179,0,0,1-1.131-1.41c-.2-.345.218-.394.6-1.113a.374.374,0,0,0-.017-.357c-.051-.1-.458-1.1-.628-1.5s-.332-.347-.458-.347a1.014,1.014,0,0,0-.932.234c-1.1,1.208-.822,2.455.119,3.78,1.848,2.419,2.833,2.865,4.634,3.483a2.818,2.818,0,0,0,1.28.082,2.1,2.1,0,0,0,1.373-.971,1.686,1.686,0,0,0,.123-.971c-.05-.092-.184-.143-.388-.235Z",
    transform: "translate(-1.906 -2.026)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_48368",
    "data-name": "Caminho 48368",
    d: "M13.976,2.349A8.175,8.175,0,0,0,.069,8.1a8.061,8.061,0,0,0,1.086,4.049L0,16.346,4.315,15.22A8.153,8.153,0,0,0,16.346,8.1a8.033,8.033,0,0,0-2.38-5.728Zm1.009,5.733A6.781,6.781,0,0,1,4.761,13.873l-.245-.146-2.554.664.684-2.483-.163-.255A6.755,6.755,0,0,1,13,3.321a6.666,6.666,0,0,1,1.981,4.761Z",
    transform: "translate(0 0)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLPwhatsappicon);
export default __webpack_public_path__ + "static/media/LPwhatsappicon.c9d98f9c8499dbc81b5b7fd31e7f586d.svg";
export { ForwardRef as ReactComponent };